import React, { useContext } from "react";
import { useSignInHandlers } from "scripts/hooks/useSignInHandlers";
import { UserContext } from "services/UserContext";
import { socialLinksForSignIn } from "utils/constants";

/**
 * Reusable Sign In Modal Component
 * Self-contained component that handles all sign-in logic internally
 * Can be used across different components (ChatWindow, DefaultLayout, etc.)
 * No props needed - uses UserContext for user data
 */
export const SignInModal: React.FC = () => {
    const { user } = useContext(UserContext) || {};
    const { handleSignIn, handleCreateAccount, handleSocialLogin } = useSignInHandlers(user?.user_id);

    return (
        <div
            id="registerLogin"
            className="modal fade modal--medium"
            role="dialog"
            aria-labelledby="rlHeading"
            aria-hidden="true"
        >
            <div
                className="modal-dialog"
                role="document"
                style={{ maxWidth: "500px" }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 id="rlHeading" className="modal-title pt-3">
                            Sign In Required
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true"></span>
                        </button>
                    </div>
                    <div className="modal-body p-2 text-left">
                        <div className="p-3 font_size--large border-bottom">
                            <div className="font-weight-normal">
                                <div id="rlLoginContent">
                                    Create an account and enjoy all the benefits of
                                    HAR.com!
                                </div>
                            </div>
                        </div>
                        <div className="p-4 over font_size--large">
                            <h3 className="mb-2">Sign In</h3>
                            <div className="">
                                <div className=" s mb-4 for-consumer">
                                    <div className="pb-3">
                                        Sign in using social account
                                    </div>
                                    {socialLinksForSignIn.map(
                                        (
                                            { icon, classname, connection_id },
                                        ) => (
                                            <a
                                                key={connection_id}
                                                className={`socialLinks text-decoration-none mr-3 ${classname}`}
                                                href="#"
                                                onClick={(e) => handleSocialLogin(e, connection_id)}
                                            >
                                                <img style={{ width: 42 }} src={icon} alt={`${connection_id} login`} />
                                            </a>
                                        )
                                    )}
                                </div>
                            </div>
                            <div className="pt-3">
                                <div className="mb-3">
                                    Sign in using HAR Account
                                </div>
                                <a
                                    id="rlSignIn"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleSignIn(e);
                                    }}
                                    className="btn btn-primary mb-3 btn--large"
                                >
                                    Sign In
                                </a>
                                <div className="row small-gutters">
                                    <div className="col-auto">
                                        Don't have an account?
                                    </div>
                                    <div className="col-auto">
                                        <a
                                            href="#"
                                            onClick={handleCreateAccount}
                                            id="rlCreateAccount"
                                        >
                                            Create one for free today!
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};
